<template>
  <div v-show="visible" ref="watermark" class="global-watermark"></div>
</template>

<script>
// 全局水印：内容为 账号+使用人+日期，随截图带出用于溯源；防删节点/改样式，被篡改后自动恢复
export default {
  name: 'GlobalWatermark',
  data () {
    return {
      observer: null,
      restoreTimer: null,
      restoring: false
    }
  },
  computed: {
    visible () {
      return this.$route.path !== '/login' && !!window.sessionStorage.getItem('token')
    }
  },
  watch: {
    $route () {
      if (this.visible) this.renderWatermark()
    }
  },
  mounted () {
    this.renderWatermark()
    this.setupGuard()
  },
  beforeDestroy () {
    this.destroyed = true
    if (this.observer) this.observer.disconnect()
    clearInterval(this.restoreTimer)
  },
  methods: {
    watermarkText () {
      const account = window.sessionStorage.getItem('account') || ''
      const name = window.sessionStorage.getItem('name') || ''
      // 招商部账号绑定员工时，实际使用人以员工为准
      const employeeName = window.sessionStorage.getItem('employeeName') || ''
      const user = employeeName || name
      const now = new Date()
      const pad = n => `${n}`.padStart(2, '0')
      const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      return [account, user, date].filter(Boolean).join('  ')
    },
    buildBackground (text) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const font = '16px "Microsoft YaHei", sans-serif'
      ctx.font = font
      canvas.width = Math.ceil(ctx.measureText(text).width) + 60
      canvas.height = 110
      ctx.font = font
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)'
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate(-22 * Math.PI / 180)
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(text, 0, 0)
      return canvas.toDataURL('image/png')
    },
    renderWatermark () {
      const el = this.$refs.watermark
      if (!el) return
      const text = this.watermarkText()
      this.renderedText = text
      el.style.backgroundImage = `url(${this.buildBackground(text)})`
    },
    setupGuard () {
      this.observer = new MutationObserver(() => this.restore())
      this.observe()
      this.restoreTimer = setInterval(this.tick, 5000)
    },
    tick () {
      this.restore()
      // 页面跨天停留时无路由跳转，靠定时器对比文本刷新日期
      if (this.visible && this.watermarkText() !== this.renderedText) this.renderWatermark()
    },
    observe () {
      const el = this.$refs.watermark
      if (!el || !this.observer) return
      this.observer.observe(el, { attributes: true })
      if (el.parentNode) this.observer.observe(el.parentNode, { childList: true })
    },
    restore () {
      if (this.destroyed || this.restoring || !this.visible) return
      const el = this.$refs.watermark
      if (!el) return
      const broken = !el.parentNode || !el.style.backgroundImage ||
        el.style.display === 'none' || !el.className.includes('global-watermark')
      if (!broken) return
      // 恢复动作本身会再次触发 observer，用 restoring 标记在微任务内挡住重入
      this.restoring = true
      if (!el.parentNode) document.getElementById('app').appendChild(el)
      if (!el.style.backgroundImage) this.renderWatermark()
      if (el.style.display === 'none') el.style.display = ''
      if (!el.className.includes('global-watermark')) el.className = 'global-watermark'
      Promise.resolve().then(() => {
        this.restoring = false
        this.observe()
      })
    }
  }
}
</script>

<style scoped>
.global-watermark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  pointer-events: none;
  background-repeat: repeat;
}
</style>
